<template>
  <div class="_additional-message-info">
    <h4 class="_section-title">
      ข้อความเพิ่มเติม
    </h4>
    <p class="_section-content">
      หรือข้อความสำหรับบรอดแคสต์ ที่สามารถซื้อเพิ่มเติมจากข้อความ ฟรีที่มีอยู่แล้วในแพ็กเกจ หากข้อความฟรีในแพ็กเกจไม่เพียงพอต่อการใช้งาน สามารถเลือกซื้อ "ข้อความเพิ่มเติม" โดยระบุจำนวนตาม ที่ต้องการใช้ได้
    </p>
  </div>
</template>

<script>
export default {
  name: 'AdditionalMessageInfo'
}
</script>

<style lang="scss" scoped>
._additional-message-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Prompt", sans-serif;
}

._section-title {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0%;
  color: #000000;
  margin: 0;
}

._section-content {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0%;
  color: #666666;
  margin: 0;
}
</style>
